import { Outlet, useParams } from "react-router";
import { createContext, useContext, useEffect, useState } from "react";
// import { IDisributorInfoExtend, IPartnerExtend } from "./DistributorDetail";
import { apiRemote } from "@/api/wp-api";
import { useAlert } from "@/contexts/AlertContext";
import { decodeId } from "@/utils/decodeId";
import { useCustomBreadcrumb } from "@/contexts/CustomBreadcrumb";
import { IUserOrder, IUserParent, IUserProfile, ICountry } from "@/api";
import { useApiCache } from "@/api/user-api";

export interface UserProfileContextType {
    profile: IUserProfile;
    countries: ICountry[];
    getUserProfile: () => Promise<any>;
}
const UserProfileContext=createContext<UserProfileContextType>({} as any);

export function UserProfileLayout(){
    const { id } = useParams<{ id: string }>(); 
    const alert=useAlert();
    const [profileData, setProfileData] = useState<IUserProfile>({}as any);
    const [countries, setCountries] = useState<ICountry[]>([]);
    const apiCache=useApiCache();
    const getUserProfile=()=>{
        return apiRemote.getUserProfile().catch((err: any) => {
            alert.error(err.message);
            return {} as IUserProfile; // Trả về giá trị mặc định khi có lỗi
        });
    }

    useEffect(()=>{
        // alert.showWait();

        const countryList = apiCache.getCountryList().catch((err) => {
            alert.error(err.message);
            return [];
        });

        // var profileDataLoaded = getUserProfile();

        Promise.all([countryList]).then(([resCountries])=>{
            // if (resProfile) {
            //     setProfileData(resProfile)
            // }
            setCountries(resCountries);
        }).catch((err)=>{
            alert.error(err.message);
        }).finally(()=>{
            // alert.hideWait();
        });



    },[id]);
    return (
        <UserProfileContext.Provider value={{profile: profileData, countries, getUserProfile}}>
            <Outlet />
        </UserProfileContext.Provider>
    )
}

export function useUserProfileContext(){
    return useContext(UserProfileContext);
}